"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentService = exports.DepartmentInviteService = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var sort_1 = require("../sort");
var index_1 = require("./index");
var DepartmentInviteService = /** @class */ (function () {
    function DepartmentInviteService(log) {
        this.log = log;
    }
    DepartmentInviteService.prototype.init = function () {
        var _this = this;
        this.userInviteFetchable = new core_shared_1.IkeFetchableMany(this.log, core_shared_1.IkeRest.createStore(), function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, index_1.Services.Department.rest.Department.Invite.list(null)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.results];
                }
            });
        }); });
        (0, mobx_1.reaction)(function () { return index_1.Services.Department.current; }, function () { return _this.userInviteFetchable.reset(); });
    };
    Object.defineProperty(DepartmentInviteService.prototype, "list", {
        get: function () {
            return this.userInviteFetchable.value;
        },
        enumerable: false,
        configurable: true
    });
    DepartmentInviteService.prototype.request = function (emails, role) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:request', String(emails.length), 1);
                        return [4 /*yield*/, index_1.Services.Department.rest.Department.Invite.do({ emails: emails, role: role })];
                    case 1:
                        _a.sent();
                        this.userInviteFetchable.refetch();
                        index_1.Services.UserProfile.refresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentInviteService.prototype.accept = function (inviteToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:accept', '', 1);
                        return [4 /*yield*/, index_1.Services.User.rest.Department.acceptInvite({ inviteToken: inviteToken })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, index_1.Services.User.rest.departments.refetch()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        _1 = _a.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DepartmentInviteService.prototype.acceptForce = function (inviteToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:acceptForce', '', 1);
                        return [4 /*yield*/, index_1.Services.Rest.rest.Verify.forceAcceptInvite({ inviteToken: inviteToken })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentInviteService.prototype.checkEmail = function (inviteToken, email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Auth, 'User_invite:checkEmail', '', 1);
                        return [4 /*yield*/, index_1.Services.Rest.rest.Verify.checkEmail({ checkToken: inviteToken, email: email })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.results];
                }
            });
        });
    };
    DepartmentInviteService.prototype.revoke = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:revoke', '', 1);
                        return [4 /*yield*/, index_1.Services.Department.rest.Verify.revoke({
                                objectId: objectId,
                                type: 'invite'
                            })];
                    case 1:
                        _a.sent();
                        this.userInviteFetchable.refetch();
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentInviteService.prototype.verify = function (inviteToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Mutate, 'User_invite:verify', '', 1);
                        return [4 /*yield*/, index_1.Services.Rest.rest.Verify.check({
                                checkToken: inviteToken,
                                type: 'invite'
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.results];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], DepartmentInviteService.prototype, "list", null);
    return DepartmentInviteService;
}());
exports.DepartmentInviteService = DepartmentInviteService;
var DepartmentService = /** @class */ (function () {
    function DepartmentService(log) {
        this.log = log;
        this.__priority = 50;
        this.Invite = new DepartmentInviteService(this.log);
        this.departments = mobx_1.observable.array([], { deep: false });
        this.writableDepartments = mobx_1.observable.array([], { deep: false });
        this.adminDepartments = mobx_1.observable.array([], { deep: false });
    }
    DepartmentService.prototype.init = function () {
        var _this = this;
        this.Invite.init();
        (0, mobx_1.reaction)(function () { return index_1.Services.SSO.token; }, function () { return _this.updateDepartments(); });
        (0, mobx_1.reaction)(function (_) { return index_1.Services.UserSettings.departmentId; }, function () { return _this.updateDepartments(); });
        (0, mobx_1.reaction)(function () { return _this.current; }, function () { return _this.updateOrg(); });
        this.updateDepartments();
    };
    DepartmentService.prototype.setUserRole = function (userId, role) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = index_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Department.User.role({ userId: userId, role: role })];
                    case 1:
                        _a.sent();
                        index_1.Services.UserProfile.refresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentService.prototype.updateDepartments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, _a, departments, adminDepartments, writeableDepartments;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        token = index_1.Services.SSO.token;
                        if (token == null) {
                            this.departments.clear();
                            this.adminDepartments.clear();
                            this.writableDepartments.clear();
                            this.current = null;
                            this.rest = null;
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [4 /*yield*/, Promise.all([
                                index_1.Services.User.rest.departments.fetch(),
                                index_1.Services.User.rest.adminDepartments.fetch(),
                                index_1.Services.User.rest.writeableDepartments.fetch()
                            ])];
                    case 1:
                        _a = _b.sent(), departments = _a[0], adminDepartments = _a[1], writeableDepartments = _a[2];
                        this.setDepartments(departments);
                        this.setAdminDepartments(adminDepartments);
                        this.setWriteableDepartments(writeableDepartments);
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentService.prototype.updateOrg = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_b = this.current) === null || _b === void 0 ? void 0 : _b.orgId)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, index_1.Services.User.rest.Org.getById({ orgId: this.current.orgId })];
                    case 1:
                        _a.currentOrg = (_c.sent());
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DepartmentService.prototype.setDepartment = function (departmentId) {
        var match = this.departments.find(function (x) { return x.objectId === departmentId; });
        if (match) {
            this.rest = index_1.Services.User.rest.bind(match.objectId);
            this.current = match;
            return;
        }
        throw new Error("Invalid department: ".concat(departmentId));
    };
    DepartmentService.prototype.hasDepartment = function (departmentId) {
        for (var _i = 0, _a = this.departments; _i < _a.length; _i++) {
            var department = _a[_i];
            if (department.objectId === departmentId) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(DepartmentService.prototype, "otherDepartmentsInOrg", {
        /** Check if the user is part of other departments of the same organization */
        get: function () {
            var current = this.current;
            if (current == null) {
                return [];
            }
            // No longer the case as all organizations have been back-filled. But still possible.
            if (current.orgId == null) {
                return [];
            }
            var otherDepartments = [];
            for (var _i = 0, _a = this.departments; _i < _a.length; _i++) {
                var department = _a[_i];
                if (department.objectId !== current.objectId && department.orgId === current.orgId) {
                    otherDepartments.push(department);
                }
            }
            return otherDepartments;
        },
        enumerable: false,
        configurable: true
    });
    DepartmentService.prototype.moveableDepartments = function () {
        var _this = this;
        var _a;
        var moveableDepartments = [];
        var isLicensedOrg = Boolean((_a = this.currentOrg) === null || _a === void 0 ? void 0 : _a.licenseCheckFrom);
        var isAnalyst = index_1.Services.User.isIkeAnalyst(index_1.Services.User.current);
        // If the user has elevated permissions, they can move to any department that they have write permissions to
        if (isLicensedOrg || isAnalyst) {
            this.writableDepartments.forEach(function (department) {
                var _a;
                // Cant move to current department
                if (department.objectId === ((_a = _this.current) === null || _a === void 0 ? void 0 : _a.objectId)) {
                    return;
                }
                moveableDepartments.push(department);
            });
        }
        // Then for every department that the user is in
        this.departments.forEach(function (department) {
            var _a, _b;
            // Cant move to current department
            if (department.objectId === ((_a = _this.current) === null || _a === void 0 ? void 0 : _a.objectId)) {
                return;
            }
            var isDepartmentOutsideOrg = department.orgId !== ((_b = _this.current) === null || _b === void 0 ? void 0 : _b.orgId);
            // We don't want outside org departments (they are handled separately above)
            if (isDepartmentOutsideOrg) {
                return;
            }
            // If is already in the list then skip it
            if (moveableDepartments.find(function (value) { return department.objectId === value.objectId; })) {
                return;
            }
            moveableDepartments.push(department);
        });
        return moveableDepartments;
    };
    DepartmentService.prototype.setAdminDepartments = function (adminDepartments) {
        this.adminDepartments.clear();
        sort_1.IkeSort.byKey(adminDepartments, 'displayName', sort_1.IkeSort.ASC);
        for (var _i = 0, adminDepartments_1 = adminDepartments; _i < adminDepartments_1.length; _i++) {
            var department = adminDepartments_1[_i];
            this.adminDepartments.push(department);
        }
    };
    DepartmentService.prototype.setWriteableDepartments = function (writeableDepartments) {
        this.writableDepartments.clear();
        sort_1.IkeSort.byKey(writeableDepartments, 'displayName', sort_1.IkeSort.ASC);
        for (var _i = 0, writeableDepartments_1 = writeableDepartments; _i < writeableDepartments_1.length; _i++) {
            var department = writeableDepartments_1[_i];
            this.writableDepartments.push(department);
        }
    };
    DepartmentService.prototype.setDepartments = function (departments) {
        this.departments.clear();
        sort_1.IkeSort.byKey(departments, 'displayName', sort_1.IkeSort.ASC);
        if (!index_1.Services.User.hasUser) {
            this.current = null;
            this.rest = null;
            return;
        }
        var departmentId = index_1.Services.UserSettings.departmentId;
        for (var _i = 0, departments_1 = departments; _i < departments_1.length; _i++) {
            var department = departments_1[_i];
            if (department.objectId === departmentId) {
                this.current = department;
            }
            this.departments.push(department);
        }
        var nextCurrent = this.current || this.pickDefaultDepartment(departments);
        if (nextCurrent) {
            this.rest = index_1.Services.User.rest.bind(nextCurrent.objectId);
        }
        if (this.current !== nextCurrent) {
            this.current = nextCurrent;
        }
    };
    DepartmentService.prototype.pickDefaultDepartment = function (departments) {
        return departments[0] == null ? null : departments[0];
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], DepartmentService.prototype, "current", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], DepartmentService.prototype, "currentOrg", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "updateDepartments", null);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "updateOrg", null);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "setDepartment", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], DepartmentService.prototype, "otherDepartmentsInOrg", null);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "moveableDepartments", null);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "setAdminDepartments", null);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "setWriteableDepartments", null);
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentService.prototype, "setDepartments", null);
    return DepartmentService;
}());
exports.DepartmentService = DepartmentService;
//# sourceMappingURL=department.service.js.map